import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeProblem } from '../components/home/HomeProblem';
import { HomeOfferings } from '../components/home/HomeOfferings';
import { HomePillars } from '../components/home/HomePillars';
import { HomeJudgmentFlow } from '../components/home/HomeJudgmentFlow';
import { HomeEcosystem } from '../components/home/HomeEcosystem';
import { HomeAudiences } from '../components/home/HomeAudiences';
import { HomeInitiatives } from '../components/home/HomeInitiatives';
import { HomeCTA } from '../components/home/HomeCTA';
export function HomePage() {
  return <>
      <HomeHero data-id="element-1724" data-mp="36rdh3aemxhe6" />
      <HomeProblem data-id="element-1725" data-mp="36rva7y603fhv" />
      <HomeOfferings data-id="element-1726" data-mp="36sevnouv0m0n" />
      <HomePillars data-id="element-1727" data-mp="31zvhoqs9fovb" />
      <HomeJudgmentFlow data-id="element-1728" data-mp="31zbxt4j1uqen" />
      <HomeEcosystem data-id="element-1729" data-mp="31ytw3sdmbjzc" />
      <HomeInitiatives data-id="element-1730" data-mp="31xiplkssfy4j" />
      <HomeAudiences data-id="element-1731" data-mp="2ea12i2kgxo7w" />
      <HomeCTA data-id="element-1732" data-mp="2e97wj3tc32qt" />
    </>;
}